import employee from "./employee"
import possetting from "./possetting"
import setting from "./setting"
export default [
    ...setting,
    ...employee,
    ...possetting
]